import { useUserContext } from "@/components/user-context/user-context-provider";

import { LoggedInJira } from "./logged-in/logged-in";
import { LoggedOutJira } from "./logged-out/logged-out-jira";

export const JiraSignup = () => {
    const {
        user: { isUserLoggedIn }
    } = useUserContext();

    if (isUserLoggedIn) {
        return <LoggedInJira />;
    }

    return <LoggedOutJira />;
};
